import { render, staticRenderFns } from "./PauseOrderReferenceButtonActionModalConfirm.vue?vue&type=template&id=5cce4271&"
import script from "./PauseOrderReferenceButtonActionModalConfirm.vue?vue&type=script&lang=js&"
export * from "./PauseOrderReferenceButtonActionModalConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports